<div class="spinner" *ngIf="appOverlaySpinner"></div>
<div [class.overlay-spinner]="appOverlaySpinner">
  <ng-content></ng-content>
</div>
